<template>
  <f7-page>
    <f7-navbar >
      <f7-nav-left back-link="" class="color-secondary" :class="{'popup-close': isFirstRoute}">
      </f7-nav-left>
      <f7-nav-title>{{ $t('CREDITS_MSG000') }}</f7-nav-title>
      <f7-nav-right>
        <Button icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary" :class="{'popup-close': isFirstRoute}" />
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar bottom no-shadow class="custom-toolbar">
      <Button :label="$t('COM_MSG002')" icon="pi pi-times" class="width-auto p-button-sm p-button-text back" :class="{'popup-close': isFirstRoute}" />
      <Button :label="$t('COM_MSG003')" icon="pi pi-check" class="width-auto p-button-sm " @click="onConfirm" />
    </f7-toolbar>

    <f7-block class="no-margin-top">
      <div class="display-flex justify-content-space-between">
        <h4>{{ $t('CREDITS_MSG001', {credits}) }}</h4>
        <f7-link href="/credits/transfer-history">{{ $t('CREDITS_MSG016') }}</f7-link>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-field p-col-12 p-sm-6 p-md-8">
          <label>{{ $t('CREDITS_MSG002') }}</label>
          <AutoComplete
              forceSelection
              v-model="subAccount"
              :suggestions="filteredSubAccounts.list"
              @complete="searchCustomer($event)"
              @blur="validateForm"
              field="CustomerName"
              :class="{'p-invalid': validationErrors.subAccount && submitted}"
          >
            <template #item="slotProps">
              <div>{{ slotProps.item.CustomerName }} <span class="text-color-gray">({{ slotProps.item.Account }} - {{ slotProps.item.Email }})</span></div>
            </template>
          </AutoComplete>
          <small>{{ $t('COM_MSG019') }}</small>
          <small v-show="validationErrors.subAccount && submitted" class="p-error">{{ $t('CREDITS_MSG003') }}</small>
        </div>
        <div class="p-field p-col-12 p-sm-6 p-md-4">
          <label>{{ $t('CREDITS_MSG004') }}</label>
          <InputNumber
              v-model="creditsToTransfer"
              showButtons
              buttonLayout="horizontal"
              :step="10"
              :min="1"
              :max="credits"
              decrementButtonClass="p-button-danger"
              incrementButtonClass="p-button-success"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              mode="decimal"
          />
        </div>
      </div>
    </f7-block>
  </f7-page>

</template>

<script>
import Dialog from 'primevue/dialog';
import InputNumber from 'primevue/inputnumber';
import AutoComplete from 'primevue/autocomplete';
import Button from "primevue/button";
import { ref, onMounted, computed, reactive  } from 'vue'
import { useStore } from 'vuex'
import {isObjEmpty} from "../../js/helper";
import {f7} from "framework7-vue";
import { useI18n } from 'vue-i18n'
/*import { ValidationProvider } from 'vee-validate';*/

export default {
  name: "credits-transfer",

  components: {
    Dialog,
    InputNumber,
    AutoComplete,
    Button,
    //ValidationProvider
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  setup(props, { emit }) {
    const { t } = useI18n()
    const store = useStore()

    let credits = computed(() => store.state.credits.Credits)
    let MinorToken = computed(() => store.state.MinorToken)
    let MajorToken = computed(() => store.state.MajorToken)
    let creditsToTransfer = ref(10)
    let submitted = ref(false)
    let validationErrors = reactive({})
    let subAccount = ref(null)
    let filteredSubAccounts = reactive({list: []})

    if(props.f7route.query.UserCode && props.f7route.query.Name){
      subAccount.value = {
        UserCode: props.f7route.query.UserCode,
        CustomerName: props.f7route.query.Name,
      }
    }

    function validateForm() {

      if (!subAccount.value || isObjEmpty(subAccount.value))
        validationErrors['subAccount'] = true;
      else
        delete validationErrors['subAccount'];

      return !Object.keys(validationErrors).length;
    }

    async function searchCustomer(event) {
      if(!event.query.trim().length || event.query.trim().length < 4 ){
        filteredSubAccounts.list = [];
        return
      }

      let customers = await store.dispatch('QUERY_CUSTOMERS', {
        MinorToken: MinorToken.value,
        MajorToken: MajorToken.value,
        q: event.query.toLowerCase(),
      })
      if(!customers){
        filteredSubAccounts.list = []
        return
      }
      filteredSubAccounts.list = customers;

      console.log(customers)
    }

    async function onConfirm() {
      submitted.value = true;
      if (!validateForm()) {
        return
      }

      console.log(subAccount.value);

      //return

      let response = await store.dispatch('CREDITS_TRANSFER', {
        MinorToken: MinorToken.value,
        MajorToken: MajorToken.value,
        ToUserCode: subAccount.value.UserCode,
        Credits: creditsToTransfer.value
      })
      console.log(response)
      if(!response){
        return
      }

      f7.dialog.alert(t('CREDITS_MSG014', { name: subAccount.value.CustomerName, credits: response.To.Credits }), t('COM_MSG020'))
      store.commit('SET_CREDITS', response.From.Credits)
      store.commit('CUSTOMER_UPDATED')
      if(props.f7route.query.isFirstRoute){
        f7.popup.close()
      }else{
        props.f7router.back()
      }
      //emit('update:isOpened', false)
    }

    return {
      isFirstRoute: !!props.f7route.query.isFirstRoute,
      credits,
      MinorToken,
      MajorToken,
      creditsToTransfer,
      subAccount,
      filteredSubAccounts,
      submitted,
      validationErrors,
      searchCustomer,
      onConfirm,
      validateForm
    }
  }
}
</script>

<style scoped>

</style>